// extracted by mini-css-extract-plugin
export default {"findPasswordContainer":"FindPassword_findPasswordContainer__dZaRd","submitSigninButton":"FindPassword_submitSigninButton__HA86+","loadingBox":"FindPassword_loadingBox__WBLA9"};